import { render, staticRenderFns } from "./NumberStyleEditor.vue?vue&type=template&id=58b151b2&"
import script from "./NumberStyleEditor.vue?vue&type=script&lang=ts&"
export * from "./NumberStyleEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports